export default "__VITE_ASSET__vr7E8Y1f__"